// ============================================================
// UnsavedChangesDialog.tsx — the shared "leave without saving?" confirm.
// Mounted once in App; shown whenever navigation/unsavedChanges asks
// (useUnsavedChangesGuard). Stay = Esc / backdrop / Cancel.
// ============================================================
import React from 'react'
import ConfirmDialogue from './ConfirmDialogue'
import { answerLeave, useLeaveConfirmOpen } from '../../navigation/unsavedChanges'

const UnsavedChangesDialog: React.FC = () => {
  const open = useLeaveConfirmOpen()
  return (
    <ConfirmDialogue
      isOpen={open}
      title="You have unsaved changes."
      message="Leave without saving?"
      confirmLabel="Discard changes"
      cancelLabel="Stay"
      tone="danger"
      onConfirm={() => answerLeave(true)}
      onCancel={() => answerLeave(false)}
    />
  )
}

export default UnsavedChangesDialog
